import React,{useState} from 'react' 
import {motion} from 'framer-motion' 
import './Two.css'
import cimg from '../assets/cimg.svg' 
  

const imgBoxVariants = {
  hidden:{
    x:100,
    opacity: 0
  },
  visible:{
    x: 0,
    opacity: 1,
    transition:{
      delay: 0.5, duration: 0.5
    }
  }
}



export const CourtImageSlider = () => { 

  const [step, setStep] = useState(1);

  const handleLeftArrow=()=>{
    if(step===1){
      setStep(3);
    }
    else{
    setStep(step-1);
    }
  }

  const handleRightArrow=()=>{
    if(step===3){
      setStep(1);
    }
    else{
      setStep(step+1);
    }
  }

  const goToSlide1=()=>{
    setStep(1);
  }

  const goToSlide2=()=>{
    setStep(2);
  }

  const goToSlide3=()=>{
    setStep(3);
  }

  return (
    <> 

<div><h2 className='text-[#272C34] font-bold text-lg py-2  text-left mt-3 '>Courts</h2></div>
<div className='wrapper w-[100%]  '>

                 

<div className='content flex justify-center '>

  

 {step===1&&<motion.div className='img-box ' variants={imgBoxVariants}
 initial="hidden" animate="visible">

 <div className=' '>
<div className='  rounded-xl   '>
    
    <img src={cimg} alt='cimg' />
    <div className='flex justify-between my-3 mx-2'>
    <h1 className='text-xs font-bold text-[#272C34]'>Padel Buddy Court name</h1>
    <h1 className='text-[#409BF5] text-xs font-bold cursor-pointer'>View court</h1>
</div>
     
</div>
</div>

           
 </motion.div>}

 {step===2&&<motion.div className='img-box' variants={imgBoxVariants}
 initial="hidden" animate="visible">
  <div className=' w-[100%]'>
<div className='   rounded '>
<img src={cimg} alt='cimg' />
<div className='flex justify-between my-3 mx-2'>
    <h1 className='text-xs font-bold text-[#272C34]'>Padel Buddy Court name</h1>
    <h1 className='text-[#409BF5] text-xs font-bold cursor-pointer'>View court</h1>
</div>
</div>
</div>        
 </motion.div>}

 {step===3&&<motion.div className='img-box' variants={imgBoxVariants}
 initial="hidden" animate="visible">
  <div className=' w-[100%]'>
<div className='   rounded '>
<img src={cimg} alt='cimg' />
<div className='flex justify-between my-3 mx-2'>
    <h1 className='text-xs font-bold text-[#272C34]'>Padel Buddy Court name</h1>
    <h1 className='text-[#409BF5] text-xs font-bold cursor-pointer'>View court</h1>
</div>
</div>
</div>        
 </motion.div>}

 

</div>

<div className='indi flex items-center md:mt-1 -mt-[3rem] p-2'>

<div className='yleft-arrow h-[50px] md:h-[65px] w-[50px] md:w-[65px] border border-gray-700 rounded-full flex justify-center item-centers py-[16px] md:py-[22px] mx-2 cursor-pointer' onClick={handleLeftArrow}>
  <i class="fa-solid fa-angle-left"></i>
  </div>

 

     <div className='yright-arrow h-[50px] md:h-[65px] w-[50px] md:w-[65px] border border-gray-700 rounded-full flex justify-center item-centers py-[16px] md:py-[22px] mx-2 cursor-pointer' onClick={handleRightArrow}>
  <i class="fa-solid fa-angle-right"  ></i>
   
  </div>

</div>

</div>
</>

)
}
 